import React, { useEffect, useState, useRef, useCallback } from 'react'
import styled from 'styled-components'
import FacilityHouseIcon from '../../asserts/icon/facility/facility-house-icon.svg'
import FacilityReportIcon from '../../asserts/icon/facility/facility-report-banner-icno.svg'
import {
  Divider,
  Dropdown,
  Input,
  Modal,
  Popconfirm,
  Table,
  message,
  Button,
  Space
} from 'antd'
import moment from 'moment'
import { useImmer } from 'use-immer'
import _ from 'lodash'
import {
  ClientEditIcon,
  // ClientMsgIcon,
  // ClientNoteIcon,
  // ClientUnreadMsgIcon,
  ClientXIcon
} from '../../asserts/svgWrappers/facilityIcons'
import PolygonAvatar from '../../components/UI/polygonAvatar'
import { SearchOutlined } from '@ant-design/icons'
import Highlighter from 'react-highlight-words'
import ClientForm from '../../components/modalFrom/clientForm'
import ExpertFormModal from '../../components/modalFrom/expertFormModal'
import FacilityFormModal from '../../components/modalFrom/facilityFormModal'
import ARDeckBannerModal from '../../components/modalFrom/arDeckBannerModal'
import {
  deleteFacility,
  deletePeople,
  facilityDetail,
  removePersonFromFacility
} from '../../api'
import FacilityAssignPersonModal, {
  FacilityModalAssignType
} from '../../components/modalFrom/facilityAssignPersonModal'
import { CharacterLevel, expertServices } from '../../utils/constant'
import PageLoading from '../../components/UI/status/loading'
import ActionAuth from '../../components/ActionAuth'
import { AuthOp, PagePermissions, PermFilter } from '../../utils/authManagement'
import PHSHeader from '../../components/UI/header'
import { useSelector } from 'react-redux'
import WelcomeEmail from '../../components/modalFrom/welcomeEmail'
import CreatedClientModal from '../../view/client/comps/createdClientModal'

const Container = styled.div`
  padding: 36px 60px;
  text-align: left;
  .back-button {
    text-decoration: underline;
    font-weight: 600;
    color: black;
    cursor: pointer;
  }
`

const MainContent = styled.div`
  .facility-name-container {
    display: flex;
    align-items: center;
    margin-top: 24px;
    font-size: 28px;
    font-weight: 600;
    & > div {
      margin-left: 25px;
    }
  }
  .facility-info-container {
    margin-top: 36px;
    display: flex;
    justify-content: space-between;
    & > div {
      font-size: 14px;
      line-height: 20px;
      color: #52606c;
      & > div {
        display: inline-block;
        &:last-child {
          margin-left: 66px;
        }
      }
    }
  }

  .report-container {
    & > div {
      color: #52606c;
      font-weight: 600;
      font-size: 21px;
    }
    .report-container-card {
      border: 1px solid #e6e9f2;
      border-radius: 12px;
      background-color: white;
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      padding: 24px;
      align-items: center;
      .report-icon-title {
        font-size: 14px;
        font-weight: 500;
        color: black;
        display: flex;
        align-items: center;
      }
    }
  }
`

const UserTableContaienr = styled.div`
  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    & > span {
      font-size: 21px;
      font-weight: 600;
      counter-reset: #323f4a;
    }
    button {
      height: 45px;
    }
  }
`

const ListActionsContainer = styled(Space).attrs({
  size: 15
})`
  .ant-space-item > span {
    cursor: pointer;
  }
`

const confirm = Modal.confirm

const Facility = (props) => {
  const {
    match: {
      params: { facilityId }
    },
    history
  } = props

  const account = useSelector((state) => state.account)

  const [facility, setFacility] = useImmer(null)
  const [clients, setClients] = useImmer([])
  const [experts, setExperts] = useImmer([])
  const [loading, setLoading] = useState(true)
  const [upsertClient, setUpsertClient] = useState(null)
  const [upsertExpert, setUpsertExpert] = useState(null)
  const [uploadBanner, setUploadBanner] = useState(null)
  const [editFacility, setEditFacility] = useState(false)
  const [createdClient, setCreatedClient] = useState(null)
  const [sendWelcomeEmail, setSendWelcomeEmail] = useState(null)
  const [searchText, setSearchText] = useState({
    expert: '',
    client: ''
  })
  const [searchedColumn, setSearchedColumn] = useState({
    expert: '',
    client: ''
  })
  const [assignModal, setAssignModal] = useState(null)

  var searchInput = useRef()

  useEffect(() => {
    const initial = async () => {
      const response = await facilityDetail(facilityId)
      setFacility(response)
      setClients(
        _.filter(response.persons, {
          person_character: CharacterLevel.client
        })
      )
      setExperts(
        _.filter(response.persons, {
          person_character: CharacterLevel.expert
        })
      )
      setLoading(false)
    }
    initial()
  }, [])

  const editItemInList = (setter) => (item) => {
    setter((draft) => {
      const index = draft.findIndex((draftItem) => draftItem.id === item.id)
      if (index > -1) {
        draft[index] = item
      }
    })
  }

  const addItemToList = (setter) => (item) => {
    setter((draft) => {
      draft.push(item)
    })
  }

  const deleteItemFromList = (setter) => (itemId) => {
    setter((draft) => {
      const index = draft.findIndex((item) => item.id === itemId)
      if (index > -1) {
        draft.splice(index, 1) // Remove the item from the array
      }
    })
  }

  const handleEditClient = useCallback(editItemInList(setClients), [])
  const handleAddClient = useCallback(addItemToList(setClients), [])
  const handleDeleteClient = useCallback(deleteItemFromList(setClients), [])

  const handleEditExpert = useCallback(editItemInList(setExperts), [])
  const handleAddExpert = useCallback(addItemToList(setExperts), [])
  const handleDeleteExpert = useCallback(deleteItemFromList(setExperts), [])

  return (
    <>
      <PHSHeader history={history} hideSubHeader={true} />
      <Container>
        {loading ? (
          <PageLoading />
        ) : (
          <>
            <div
              className="back-button"
              onClick={() => {
                history.push('/')
              }}
            >
              Back
            </div>
            <MainContent>
              <div className="facility-name-container">
                <img src={FacilityHouseIcon} alt="icon" />
                <div>{facility.name}</div>
              </div>
              <div className="facility-info-container">
                <div className="">
                  <div>
                    <div>Address: {facility.address}</div>
                    <div>Phone Number: {facility.phone_number || '--'}</div>
                  </div>
                  <div>
                    <div>
                      Open:{' '}
                      {moment(facility.open_time, 'HH:mm:ss').format('h:mm A')}{' '}
                      - Close:{' '}
                      {moment(facility.close_time, 'HH:mm:ss').format('h:mm A')}
                    </div>
                    <div>
                      Service Available:{' '}
                      {(facility.services || ['--']).join(',')}
                    </div>
                  </div>
                </div>
                <ActionAuth
                  permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
                >
                  <Button
                    type="primary"
                    ghost
                    onClick={() => {
                      setEditFacility(true)
                    }}
                  >
                    Edit Info
                  </Button>
                </ActionAuth>
              </div>
              <Divider />
              <UserTableContaienr>
                <div className="table-title">
                  <span>Experts</span>
                  <ActionAuth
                    permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
                  >
                    <Dropdown
                      menu={{
                        items: [
                          {
                            label: 'Create a new expert',
                            key: 'create_new_expert'
                          },
                          {
                            label: 'Add an existing expert',
                            key: 'add_existing_expert'
                          }
                        ],
                        onClick: ({ key }) => {
                          if (key === 'add_existing_expert') {
                            setAssignModal(FacilityModalAssignType.addExpert)
                          } else {
                            setUpsertExpert({
                              facility_ids: [facility.id]
                            })
                          }
                        }
                      }}
                      trigger={['click']}
                    >
                      <Button type="primary">+ Add</Button>
                    </Dropdown>
                  </ActionAuth>
                </div>
                <Table
                  columns={getExpertsListColumns()}
                  dataSource={experts}
                  rowKey={(record) => record.id}
                />
              </UserTableContaienr>
              <Divider />
              <UserTableContaienr>
                <div className="table-title">
                  <span>Clients</span>
                  <ActionAuth
                    permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
                  >
                    <Dropdown
                      menu={{
                        items: [
                          {
                            label: 'Create a new client',
                            key: 'create_new_client'
                          },
                          {
                            label: 'Add an existing client',
                            key: 'add_existing_client'
                          }
                        ],
                        onClick: ({ key }) => {
                          if (key === 'add_existing_client') {
                            setAssignModal(FacilityModalAssignType.addClient)
                          } else {
                            setUpsertClient({
                              facility_ids: [facility.id]
                            })
                          }
                        }
                      }}
                      trigger={['click']}
                    >
                      <Button type="primary">+ Add</Button>
                    </Dropdown>
                  </ActionAuth>
                </div>
                <Table
                  columns={getClientsListColumns()}
                  dataSource={clients}
                  rowKey={(record) => record.id}
                />
              </UserTableContaienr>
              <Divider />
              <div className="report-container">
                <div>Reports</div>
                <div className="report-container-card">
                  <div className="report-icon-title">
                    <img src={FacilityReportIcon} alt="ar-deck-icon" />
                    <span
                      style={{
                        fontWeight: 600,
                        marginLeft: '22px'
                      }}
                    >
                      AR Deck
                    </span>
                  </div>
                  <ActionAuth
                    permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
                    fallback={
                      <Button
                        ghost
                        type="primary"
                        onClick={() => {
                          setUploadBanner({
                            viewOnly: true
                          })
                        }}
                      >
                        View Banner
                      </Button>
                    }
                  >
                    <Button
                      ghost
                      type="primary"
                      onClick={() => {
                        setUploadBanner({})
                      }}
                    >
                      Upload Banner
                    </Button>
                  </ActionAuth>
                </div>
              </div>
            </MainContent>
            {upsertClient && (
              <ClientForm
                onCancel={() => setUpsertClient(null)}
                facilities={[facility]}
                initValue={upsertClient}
                submitSync={clientSubmitSync}
                onDelete={() => onDeleteClient(upsertClient)}
                lockFacility={true}
                experts={experts}
                currentFacility={facility}
                allowDelete={false}
                editEmail={() => {
                  setUpsertClient(null)
                  setSendWelcomeEmail({ ...upsertClient })
                }}
              />
            )}
            {upsertExpert && (
              <ExpertFormModal
                onCancel={() => setUpsertExpert(null)}
                facilities={[facility]}
                initValue={upsertExpert}
                submitSync={expertSubmitSync}
                onDelete={handleDeleteExpert}
                lockFacility={true}
                allowDelete={false}
              />
            )}
            {uploadBanner && (
              <ARDeckBannerModal
                facility={facility}
                onCancel={() => {
                  setUploadBanner(false)
                }}
                saveSync={(banner) => {
                  setUploadBanner(false)
                  setFacility((draft) => {
                    draft.banner = banner
                  })
                }}
                {...uploadBanner}
              />
            )}
            {assignModal && (
              <FacilityAssignPersonModal
                facility={facility}
                confirmSync={(selectedClients, selectedExperts) => {
                  for (const client of selectedClients) {
                    handleAddClient(client)
                  }
                  for (const expert of selectedExperts) {
                    handleAddExpert(expert)
                  }
                  setAssignModal(null)
                }}
                assignModal={assignModal}
                onCancel={() => setAssignModal(null)}
              />
            )}
            {editFacility && (
              <FacilityFormModal
                onCancel={() => setEditFacility(false)}
                initValue={facility}
                submitSync={(newObj, syncType) => {
                  setFacility((draft) => {
                    _.assign(draft, newObj)
                  })
                  setEditFacility(false)
                }}
                onDelete={onDeleteFacility}
              />
            )}
            {createdClient && (
              <CreatedClientModal
                send={() => {
                  setCreatedClient(null)
                  setSendWelcomeEmail(_.cloneDeep(createdClient))
                }}
                skip={() => setCreatedClient(null)}
              />
            )}
            {sendWelcomeEmail && (
              <WelcomeEmail
                onCancel={() => setSendWelcomeEmail(null)}
                person={sendWelcomeEmail}
                experts={experts}
              />
            )}
          </>
        )}
      </Container>
    </>
  )

  function getClientsListColumns() {
    return [
      {
        key: 'avatar',
        width: 74,
        render: (text, record) => (
          <PolygonAvatar
            width={46}
            image={record.avatar && record.avatar.oss_url}
            innerId={`list-inner-${record.id}`}
            hexId={`list-hex-${record.id}`}
          />
        )
      },
      {
        title: 'NAME',
        key: 'name',
        ...getColumnSearchProps('name', 'client'),
        sorter: (a, b) => {
          const aName = `${a.profile.nickname || a.first_name} ${a.last_name}`
          const bName = `${b.profile.nickname || b.first_name} ${b.last_name}`

          return (
            aName.toLowerCase().charCodeAt() - bName.toLowerCase().charCodeAt()
          )
        },
        sortDirections: ['descend', 'ascend'],
        render: (text, record, index) => {
          const name = `${record.profile.nickname || record.first_name} ${
            record.last_name
          }`
          return (
            <>
              {searchedColumn['client'] === 'name' ? (
                <Highlighter
                  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                  searchWords={getSearchWords('client')}
                  autoEscape
                  textToHighlight={name.toString()}
                />
              ) : (
                name
              )}
            </>
          )
        }
      },
      {
        title: 'GROUP EXPERTS',
        key: 'group_experts',
        render: (text, record, index) => {
          return record.group_experts
            .map((groupExpert) => {
              const expert = experts.find((i) => i.id === groupExpert)
              if (expert) {
                return expert.first_name
              } else {
                return null
              }
            })
            .join(', ')
        }
      },
      {
        key: 'action',
        title: 'ACTIONS',
        width: 110,
        render: (text, record, index) => {
          return (
            <ListActionsContainer>
              <ActionAuth
                permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
              >
                <span>
                  <ClientEditIcon
                    onClick={() => {
                      setUpsertClient(record)
                    }}
                  />
                </span>
              </ActionAuth>
              {/* <span>
                <ClientMsgIcon />
              </span>
              <span>
                <ClientNoteIcon />
              </span> */}
              <ActionAuth
                permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
              >
                <span>
                  <Popconfirm
                    icon={<></>}
                    title="Are you sure you want to remove the client in the facility?"
                    okText="REMOVE"
                    cancelText="CANCEL"
                    okType="danger"
                    onConfirm={() =>
                      removePersonFromFacility(facility.id, record.id).then(
                        () => {
                          handleDeleteClient(record.id)
                        }
                      )
                    }
                  >
                    <ClientXIcon />
                  </Popconfirm>
                </span>
              </ActionAuth>
            </ListActionsContainer>
          )
        },
        perm: [PagePermissions.FACILITY, AuthOp.UPDATE]
      }
    ].filter((c) => PermFilter(_.get(c, 'perm'), account))
  }

  function getExpertsListColumns() {
    return [
      {
        key: 'avatar',
        render: (text, record) => {
          return (
            <PolygonAvatar
              width={46}
              image={record.avatar && record.avatar.oss_url}
              innerId={`list-inner-${record.id}`}
              hexId={`list-hex-${record.id}`}
            />
          )
        }
      },
      {
        title: 'NAME',
        key: 'name',
        ...getColumnSearchProps('name', 'expert'),
        sorter: (a, b) => {
          const aName = `${a.profile.nickname || a.first_name} ${a.last_name}`
          const bName = `${b.profile.nickname || b.first_name} ${b.last_name}`

          return (
            aName.toLowerCase().charCodeAt() - bName.toLowerCase().charCodeAt()
          )
        },
        sortDirections: ['descend', 'ascend'],
        render: (text, record, index) => {
          const name = `${record.profile.nickname || record.first_name} ${
            record.last_name
          }`
          return (
            <>
              {searchedColumn['expert'] === 'name' ? (
                <Highlighter
                  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                  searchWords={getSearchWords('expert')}
                  autoEscape
                  textToHighlight={name.toString()}
                />
              ) : (
                name
              )}
            </>
          )
        }
      },
      {
        title: 'SERVICE',
        dataIndex: 'services',
        filterMultiple: false,
        filters: expertServices.map((i) => {
          return {
            text: i,
            value: i
          }
        }),
        onFilter: (value, record) => {
          return record.services.includes(value)
        },
        render: (text, record, index) => {
          return (_.get(record, 'services') || []).join(', ')
        }
      },
      {
        title: 'CONTACT',
        render: (text, record, index) => {
          return (
            <div>
              <div>{record.email}</div>
              {record.profile.phone_number && (
                <div>{record.profile.phone_number}</div>
              )}
            </div>
          )
        }
      },
      {
        key: 'action',
        title: 'ACTIONS',
        width: 110,
        render: (text, record, index) => {
          return (
            <ListActionsContainer>
              <ActionAuth
                permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
              >
                <span onClick={() => setUpsertExpert(record)}>
                  <ClientEditIcon />
                </span>
              </ActionAuth>
              <ActionAuth
                permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
              >
                <span>
                  <Popconfirm
                    icon={<></>}
                    title="Are you sure you want to remove the expert in the facility?"
                    okText="REMOVE"
                    cancelText="CANCEL"
                    okType="danger"
                    onConfirm={() =>
                      removePersonFromFacility(facility.id, record.id).then(
                        () => {
                          handleDeleteExpert(record.id)
                        }
                      )
                    }
                  >
                    <ClientXIcon />
                  </Popconfirm>
                </span>
              </ActionAuth>
            </ListActionsContainer>
          )
        },
        perm: [PagePermissions.FACILITY, AuthOp.UPDATE]
      }
    ].filter((c) => PermFilter(_.get(c, 'perm'), account))
  }

  function getColumnSearchProps(dataIndex, type) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              searchInput = node
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, dataIndex, type)
            }
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            fontWeight={500}
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex, type)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            fontWeight={500}
            onClick={() => handleReset(clearFilters, type)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) => {
        const values = value.split(',')
        let filterValue = record[dataIndex]
        if (dataIndex === 'location') {
          filterValue =
            record.profile && record.profile.city ? record.profile.city : ''
        } else if (dataIndex === 'name') {
          filterValue = `${record.profile.nickname || record.first_name} ${
            record.last_name
          }`
        }
        return values.find((_value) =>
          filterValue
            .toString()
            .toLowerCase()
            .includes(_value.toLowerCase().trim())
        )
      },
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.select())
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={getSearchWords(type)}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
    }
  }

  function handleSearch(selectedKeys, confirm, dataIndex, type) {
    setSearchText(_.assign({ ...searchText }, { [type]: selectedKeys[0] }))
    setSearchedColumn(_.assign({ ...searchedColumn }, { [type]: dataIndex }))
    confirm()
  }

  function handleReset(clearFilters, type) {
    clearFilters()
    setSearchText(_.assign({ ...searchText }, { [type]: '' }))
  }

  function getSearchWords(type) {
    return searchText[type]
      ? searchText[type].split(',').map((item) => item.trim())
      : []
  }

  function clientSubmitSync(client, type) {
    if (type === 'update') {
      handleEditClient(client)
    } else {
      handleAddClient(client)
      setUpsertClient(null)
      setCreatedClient(client)
    }
  }

  function expertSubmitSync(expert, type) {
    if (type === 'update') {
      handleEditExpert(expert)
    } else {
      handleAddExpert(expert)
      setUpsertExpert(null)
    }
  }

  function onDeleteFacility(facility) {
    confirm({
      title: `Do you want to delete facility: ${facility.name}?`,
      icon: <></>,
      width: '546px',
      content: <></>,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        return handleDeleteFacility(facility)
      },
      onCancel() {}
    })
  }

  async function deletingClient(id) {
    try {
      await deletePeople(id)
      handleDeleteClient(id)
      setUpsertClient(null)
      message.success('The account has been deleted!')
    } catch (err) {
      console.error(err)
      message.warning(err.message)
    }
  }

  function onDeleteClient(record) {
    const isExpert = record.person_character === CharacterLevel.expert
    confirm({
      title: `Do you want to delete ${isExpert ? 'expert' : 'client'}: ${record
        .profile.nickname || record.first_name} ${record.last_name}?`,
      icon: <></>,
      // className: deleteClientStyle,
      width: '546px',
      content: (
        <>
          <p>Please be aware when this account is deleted:</p>
          <ul>
            <li>You can't access this account anymore</li>
            <li>This account will no longer be able to log in</li>
            <li>
              You will not be able to retrieve this account data or reactivate
              this account. This is a permanent action
            </li>
            {!isExpert && (
              <li>Programs (if any) of this account will be canceled</li>
            )}
          </ul>
        </>
      ),
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        return deletingClient(record.id)
      },
      onCancel() {}
    })
  }

  async function handleDeleteFacility(facility) {
    try {
      await deleteFacility(facility.id)
      history.push('/')
    } catch (err) {
      console.error(err)
      message.warning(err.message)
    }
  }
}

export default Facility
